import { tsUtils } from '@neo-one/ts-utils';
export const hasAttribute = (context, node, type) => tsUtils.type_.hasType(type, (tpe) => isAttribute(context, node, tpe));
export const isOnlyAttribute = (context, node, type) => tsUtils.type_.isOnlyType(type, (tpe) => isAttribute(context, node, tpe));
export const isAttribute = (context, node, type) => context.builtins.isInterface(node, type, 'AttributeBase') ||
    context.builtins.isInterface(node, type, 'BufferAttribute') ||
    context.builtins.isInterface(node, type, 'PublicKeyAttribute') ||
    context.builtins.isInterface(node, type, 'AddressAttribute') ||
    context.builtins.isInterface(node, type, 'Hash256Attribute') ||
    context.builtins.isType(node, type, 'Attribute');

//# sourceMappingURL=typeTests.js.map
